import { z } from 'zod';

import { apiGet } from '../client';

/** One open time the public booking flow would offer, from GET /v1/availability. */
export const OpenSlotSchema = z.object({
  id: z.string(),
  businessId: z.string(),
  serviceId: z.string(),
  startsAt: z.string(),
  staffId: z.string().optional(),
});
export type OpenSlot = z.infer<typeof OpenSlotSchema>;

const OpenSlotListSchema = z.object({ data: z.array(OpenSlotSchema) });

/** The same free times a customer sees, so a link never offers one they cannot confirm. */
export function listOpenSlots(businessId: string, serviceId: string, date: string): Promise<OpenSlot[]> {
  const query = new URLSearchParams({ businessId, serviceId, date });
  return apiGet(`/v1/availability?${query.toString()}`, OpenSlotListSchema).then((result) => result.data);
}
